import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_OPTIONS } from 'data-hooks/queries';
import usePDPApolloQueryVariables from 'data-hooks/usePDPApolloQueryVariables';
import isNewConsumerApp from 'commons/isNewConsumerApp';
const usePDPQueryOptionsForProductOld = (t0, t1) => {
  const $ = _c(11);
  const {
    id,
    slug
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    skip
  } = t2;
  const {
    variables: productOptionsVariables,
    skip: skipProductOptionsQuery
  } = usePDPApolloQueryVariables(id, slug);
  const t3 = skip || skipProductOptionsQuery;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      noBatch: true
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== productOptionsVariables || $[4] !== t3) {
    t5 = {
      variables: productOptionsVariables,
      skip: t3,
      context: t4
    };
    $[3] = productOptionsVariables;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    loading,
    error,
    data
  } = useSuspenseQuery(PRODUCT_OPTIONS, t5);
  const t6 = loading && !data;
  let t7;
  if ($[6] !== data || $[7] !== error || $[8] !== skipProductOptionsQuery || $[9] !== t6) {
    t7 = {
      loading: t6,
      error,
      data,
      skipProductOptionsQuery
    };
    $[6] = data;
    $[7] = error;
    $[8] = skipProductOptionsQuery;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
const usePDPQueryOptionsForProductNew = (t0, t1) => {
  const $ = _c(16);
  const {
    id,
    slug,
    initialProductOptions: productOptions
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    skip
  } = t2;
  let t3;
  if ($[2] !== id || $[3] !== slug) {
    t3 = id ? {
      id
    } : slug ? {
      slug
    } : {};
    $[2] = id;
    $[3] = slug;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const variables = t3;
  const shouldSkip = skip || !id && !slug || !!productOptions;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      noBatch: true
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== shouldSkip || $[7] !== variables) {
    t5 = {
      variables,
      skip: shouldSkip,
      context: t4
    };
    $[6] = shouldSkip;
    $[7] = variables;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    loading,
    error,
    data
  } = useSuspenseQuery(PRODUCT_OPTIONS, t5);
  if (productOptions) {
    let t6;
    if ($[9] !== productOptions) {
      t6 = {
        loading: false,
        error: null,
        data: productOptions,
        skipProductOptionsQuery: false
      };
      $[9] = productOptions;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  const t6 = loading && !data;
  let t7;
  if ($[11] !== data || $[12] !== error || $[13] !== shouldSkip || $[14] !== t6) {
    t7 = {
      loading: t6,
      error,
      data,
      skipProductOptionsQuery: shouldSkip
    };
    $[11] = data;
    $[12] = error;
    $[13] = shouldSkip;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};

// Export the appropriate version based on isNewConsumerApp
const usePDPQueryOptionsForProduct = isNewConsumerApp ? usePDPQueryOptionsForProductNew : usePDPQueryOptionsForProductOld;
export default usePDPQueryOptionsForProduct;